import dangerSign from "../assets/images/danger.jpg";

const Images = {
  dangerSign,
};

export default Images;
